import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import * as TEXT from '../../../../constants/texts';
import { GENERAL } from '../../../../constants/endpoints.js';
import styles from './style';
import logo from '../../../../../static/aula-logo-login.svg';

@Radium
class NavigationBar extends React.Component {
  render() {
    return (
      <div style={styles.container}>
        <div>
          <img src={logo} alt="Aula" width="100" height="40" />
        </div>

        {!this.props.hideActionButton &&
          (this.props.deep ? (
            <div
              style={styles.backButton}
              key="back"
              onClick={() => window.history.back()}
            >
              {TEXT.BUTTON_BACK}
            </div>
          ) : (
            <a style={{ textDecoration: 'none' }} key="back" href={GENERAL}>
              <div style={styles.backButton}>{TEXT.BUTTON_BACK}</div>
            </a>
          ))}

        <span style={styles.linksWrapper}>
          <a
            style={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            href="https://data.aula.education/Terms_of_Service.pdf"
          >
            {TEXT.BUTTON_TERMS}
          </a>
          <a
            style={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            href="https://data.aula.education/Privacy_Policy.pdf"
          >
            {TEXT.BUTTON_PRIVACY}
          </a>
        </span>
      </div>
    );
  }
}

NavigationBar.propTypes = {
  deep: PropTypes.bool.isRequired,
  hideActionButton: PropTypes.bool,
};

export default NavigationBar;
